import * as React from 'react';

import { BLOCK_LIST_OL } from '@gitbook/doc-core';
import { isList } from '@gitbook/doc-core/src/list';
import type { BlockProps } from '@gitbook/slate-react';
import { assert } from '@gitbook/util-ts';

import { BlockWrapper } from '../common';
import { ListContext } from './ListContext';
import { useListItemBlockPaletteFactory } from './palette';

/**
 * Renderer for a list block.
 */
export function BlockList(props: BlockProps): React.ReactElement {
    const { node, children, attributes } = props;
    assert(isList(node), 'BlockList must be a list block');
    const ListTag = node.type === BLOCK_LIST_OL ? 'ol' : 'ul';
    const parentListContext = React.useContext(ListContext);
    const depth = parentListContext?.type === node.type ? parentListContext.depth + 1 : 0;
    const listContext = React.useMemo(() => ({ type: node.type, depth }), [node.type, depth]);

    const firstChild = node.nodes.first();
    assert(firstChild, 'List block must have at least one child');
    const palette = useListItemBlockPaletteFactory({ nodeKey: firstChild.key });

    return (
        <BlockWrapper palette={palette} {...props}>
            <ListTag {...attributes}>
                <ListContext.Provider value={listContext}>{children}</ListContext.Provider>
            </ListTag>
        </BlockWrapper>
    );
}
